const config = {
  lookups: {
    getEmirates: `${process.env.REACT_APP_BASE_URL}Lookup/GetEmirates`,
    getCities: `${process.env.REACT_APP_BASE_URL}Lookup/GetCities`,
    getCDUCities: `${process.env.REACT_APP_BASE_URL}Lookup/GetCDUCities`,
    getLookupValues: `${process.env.REACT_APP_BASE_URL}Lookup/GetLookupValues`,
    getSystems: `${process.env.REACT_APP_BASE_URL}Lookup/RetrieveSystemService`,
    getAppointmentStatus: `${process.env.REACT_APP_BASE_URL}Lookup/GetLookupValues`,
    getServiceTerritories: `${process.env.REACT_APP_BASE_URL}Lookup/RetrieveTerritories`,
    getCDUServiceTerritories: `${process.env.REACT_APP_BASE_URL}Lookup/RetrieveCDUTerritories`,
    getOnHoldReason: `${process.env.REACT_APP_BASE_URL}Lookup/RetrieveOnHoldReason`,
    assignedBuildings: `${process.env.REACT_APP_BASE_URL}Lookup/RetrieveBuildingsByBMC`,
    assignedBuildingsForInvoices: `${process.env.REACT_APP_BASE_URL}Lookup/RetrieveBuildingsByBMCForInvoice`,
  },
  users: {
    signInUser: `${process.env.REACT_APP_BASE_URL}Authentication/SignIn`,
    restPassword: `${process.env.REACT_APP_BASE_URL}Authentication/ResetPassword`,
    verifyOTPPhoneNumber: `${process.env.REACT_APP_BASE_URL}Authentication/VerifyOTPPhoneNumber`,
    verifyOTPEmail: `${process.env.REACT_APP_BASE_URL}Authentication/VerifyOTPEmail`,
    forgetPassword: `${process.env.REACT_APP_BASE_URL}Authentication/ForgotPassword`,
  },
  BMCCompany: {
    getBMCWithRating: `${process.env.REACT_APP_BASE_URL}CivilDefense/ViewBMCsListwithRatings`,
    getProfile: `${process.env.REACT_APP_BASE_URL}BMCCompany/Profile`,
    updateBMC: `${process.env.REACT_APP_BASE_URL}BMCCompany/UpdateBMC`,
    registerBMC: `${process.env.REACT_APP_BASE_URL}BMCCompany/RegisterBMC`,
    getAssignedBuilding: `${process.env.REACT_APP_BASE_URL}BMCCompany/RetrieveBuildingInfoById?propertyId=`,
    getByContractId: `${process.env.REACT_APP_BASE_URL}BMCCompany/RetrieveContractById?contractId=`,
    retrieveBuildingsByBMC: `${process.env.REACT_APP_BASE_URL}BMCCompany/RetrieveBuildingsByBMC`,
    ValidateContractNumber: `${process.env.REACT_APP_BASE_URL}BMCCompany/ValidateContractNumber`,
    retrieveEngineerTechnicianByBMC: `${process.env.REACT_APP_BASE_URL}BMCCompany/RetriveContractsBySupervisorName`,
    retrieveBuildingInfoById: `${process.env.REACT_APP_BASE_URL}BMCCompany/RetrieveBuildingInfoById`,
    saveAPI: `${process.env.REACT_APP_BASE_URL}BMCCompany/AssignContractToBuilding`,
    isCompanyNameUnique: `${process.env.REACT_APP_BASE_URL}BMCCompany/IsCompanyNameUnique`,
    isEmailUnique: `${process.env.REACT_APP_BASE_URL}BMCCompany/IsEmailUnique`,
    isPhoneNumberUnique: `${process.env.REACT_APP_BASE_URL}BMCCompany/IsPhoneNumberUnique`,
    generateOTPToken: `${process.env.REACT_APP_BASE_URL}Authentication/GenerateOTPToken`,
    validateOTPToken: `${process.env.REACT_APP_BASE_URL}Authentication/ValidateOTPToken`,
    saveSurvey: `${process.env.REACT_APP_BASE_URL}SurveyRequest/AddSurveyRequest`,
    sendRequestToOwner: `${process.env.REACT_APP_BASE_URL}BMCCompany/SendRequestToOwner`,
    maintenanceAppointmentsStatistics: `${process.env.REACT_APP_BASE_URL}BMCCompany/MaintenanceAppointmentsStatistics`,
    maintenanceRequestsStatistics: `${process.env.REACT_APP_BASE_URL}BMCCompany/MaintenanceRequestsStatistics`,
    ateCasesStatistics: `${process.env.REACT_APP_BASE_URL}BMCCompany/ATECasesStatistics`,
    contractInformationStatistics: `${process.env.REACT_APP_BASE_URL}BMCCompany/ContractInformationStatistics`,
    dashboardCards: `${process.env.REACT_APP_BASE_URL}BMCCompany/DashboardCards`,
    buildingsStatistics: `${process.env.REACT_APP_BASE_URL}BMCCompany/BuildingsStatistics`,
    validateUnassignSystemContract: `${process.env.REACT_APP_BASE_URL}BMCCompany/ValidateUnassignSystemContract`,
    unAssignSystemServices: `${process.env.REACT_APP_BASE_URL}BMCCompany/UnAssingSystemServices`,
    retrieveSystemServicesByBuilding: `${process.env.REACT_APP_BASE_URL}BMCCompany/RetrieveSystemServicesByBuilding`,
    validateSystemService: `${process.env.REACT_APP_BASE_URL}BMCCompany/ValidateSystemService`,
    unAssingBuilding: `${process.env.REACT_APP_BASE_URL}BMCCompany/UnAssingBuilding`,
  },
  appointments: {
    getAppointments: `${process.env.REACT_APP_BASE_URL}Appointment/RetrieveAppointmentsByBMC`,
    getCDAppointments: `${process.env.REACT_APP_BASE_URL}Appointment/RetrieveAppointmentsByCDU`,
    updateStatus: `${process.env.REACT_APP_BASE_URL}Appointment/UpdateAppointmentStatus`,
    retrieveAppointmentStatusForEdit: `${process.env.REACT_APP_BASE_URL}Appointment/RetrievAppointmentStatusForEdit`,
  },
  Case: {
    retrieveMaintenanceRequests: `${process.env.REACT_APP_BASE_URL}Case/RetrieveMaintenanceRequests`,
    retrieveMaintenanceRequestByTicketNumber: `${process.env.REACT_APP_BASE_URL}Case/RetrieveMaintenanceRequestByTicketNumber`,
    RetrieveATECaseRequests: `${process.env.REACT_APP_BASE_URL}Case/RetrieveATECaseRequests`,
    RetrieveCDUCaseRequests: `${process.env.REACT_APP_BASE_URL}Case/RetrieveCDUCaseRequests`,
    updateStatus: `${process.env.REACT_APP_BASE_URL}Case/UpdateCaseStatus`,
    getCaseStatuses: `${process.env.REACT_APP_BASE_URL}Case/RetrieveCaseStatus`,
    retrieveCaseStatusForEditCase: `${process.env.REACT_APP_BASE_URL}Case/RetrieveCaseStatusForEditCase`,
    retrieveMaintenanceStatusForEdit: `${process.env.REACT_APP_BASE_URL}Case/RetrieveMaintenaceStatusForEdit`,
  },
  Invoices: {
    getInvoices: `${process.env.REACT_APP_BASE_URL}Invoices/GetInvoices`,
    getConsolidatedInvoices: `${process.env.REACT_APP_BASE_URL}Invoices/GetConsolidatedInvoices`,
    generateInvoiceURL: `${process.env.REACT_APP_BASE_URL}Invoices/GenerateInvoiceURL?InvoiceId=`,
    generateConsolidatedInvoiceURL: `${process.env.REACT_APP_BASE_URL}Invoices/GenerateInvoiceURLForConslidate`,
    getInvoiceDetails: `${process.env.REACT_APP_BASE_URL}Invoices/GetInvoiceDetails`,
    getConsolidatedInvoiceDetails: `${process.env.REACT_APP_BASE_URL}Invoices/GetConsolidatedInvoiceDetails`,
    createConsolidatedInvoice: `${process.env.REACT_APP_BASE_URL}Invoices/CreateConsolidatedInvoice`,
    getUnpaidConsolidatedInvoiceHeaders: `${process.env.REACT_APP_BASE_URL}Invoices/GetUnpaidConsolidatedInvoiceHeaders`,
    updateConsolidatedInvoice: `${process.env.REACT_APP_BASE_URL}Invoices/UpdateConsolidatedInvoice`,
    getPaymentClearance: `${process.env.REACT_APP_BASE_URL}Invoices/GetPaymentClearance`,
  },
  CivilDefense: {
    signIn: `${process.env.REACT_APP_BASE_URL}CivilDefense/SignIn`,
    getProfile: `${process.env.REACT_APP_BASE_URL}CivilDefense/Profile`,
    resetPassword: `${process.env.REACT_APP_BASE_URL}CivilDefense/ResetPassword`,
    sendRequestToBMC: `${process.env.REACT_APP_BASE_URL}CivilDefense/SubmitRequestWithBuilding`,
    getBMCTemplates: `${process.env.REACT_APP_BASE_URL}CivilDefense/NotificationTemplatesList?BMCId=`,
    getBMCs: `${process.env.REACT_APP_BASE_URL}CivilDefense/BMCsList`,
    maintenanceAppointmentsStatistics: `${process.env.REACT_APP_BASE_URL}CivilDefense/MaintenanceAppointmentsStatistics`,
    maintenanceRequestsStatistics: `${process.env.REACT_APP_BASE_URL}CivilDefense/MaintenanceRequestsStatistics`,
    ateCasesStatistics: `${process.env.REACT_APP_BASE_URL}CivilDefense/CaseStatistics`,
    contractInformationStatistics: `${process.env.REACT_APP_BASE_URL}CivilDefense/ContractStatistics`,
    dashboardCards: `${process.env.REACT_APP_BASE_URL}CivilDefense/DashboardCards`,
    buildingsStatistics: `${process.env.REACT_APP_BASE_URL}CivilDefense/BuildingsStatistics`,
    bmcRatingStatistics: `${process.env.REACT_APP_BASE_URL}CivilDefense/BMCStatisticsWithRatings`,
    getBuildings: `${process.env.REACT_APP_BASE_URL}CivilDefense/Buildings`,
  },
};
export default config;
